export const selectTranscriptIsShowing = ({ transcript }) =>
  transcript.isShowing;
